import { render, staticRenderFns } from "./optimize-script.vue?vue&type=template&id=35a59b93&scoped=true"
import script from "./optimize-script.vue?vue&type=script&setup=true&lang=js"
export * from "./optimize-script.vue?vue&type=script&setup=true&lang=js"
import style0 from "./optimize-script.vue?vue&type=style&index=0&id=35a59b93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a59b93",
  null
  
)

export default component.exports